import api from './client';

export const listLegalDocs = (params = {}) =>
  api.get('/legal/admin/documents', { params }).then(r => r.data);

export const createLegalDoc = (data) =>
  api.post('/legal/admin/documents', data).then(r => r.data);

export const updateLegalDoc = (id, data) =>
  api.put(`/legal/admin/documents/${id}`, data).then(r => r.data);

export const publishLegalDoc = (id) =>
  api.post(`/legal/admin/documents/${id}/publish`).then(r => r.data);
